import React, { useState, useRef } from 'react';
import { Button } from '../buttons';

interface CopyToClipboardProps {
  text: string;
  className: string;
}

function CopyToClipboard({ text, className }: CopyToClipboardProps) {
  const [isCopied, setIsCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleCopy = async () => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(text);
    } else {
      document.execCommand('copy', true, text);
    }
    showCopied();
  };

  const showCopied = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const handleFocus = () => {
    if (inputRef.current !== null) {
      inputRef.current.select();
    }
  };

  return (
    <div className={`flex flex-row items-center mb-6 ${className}`}>
      <input
        readOnly
        ref={inputRef}
        value={text}
        className="border border-thryv-gray-light-500 rounded px-2 py-1 w-[90%] mr-[20px]"
        onFocus={handleFocus}
        aria-label="Content to be copied"
      />
      <div className="relative">
        <Button
          variant="form"
          level={1}
          onClick={handleCopy}
          aria-describedby={`Copy message: ${text}`}
        >
          Copy
        </Button>
        {isCopied && <p className="absolute text-center w-full">Copied!</p>}
      </div>
    </div>
  );
}

export default CopyToClipboard;
